import { j as r } from "../../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../../index-CROKJrb5.js";
import { c as n, f as u } from "../../../../create-component-CBAeEoQ6.js";
import { RadioButton as d } from "../../../RadioButton/index.js";
import { Label as f } from "../../../Label/index.js";
const R = n(
  "ControlCardRadioButton",
  u(
    ({ as: o, children: e, className: t, recommended: s, label: a, ...c }, i) => {
      const l = o || "div";
      return /* @__PURE__ */ r.jsx(l, { className: m("cur-relative cur-z-10 cur-mb-0", t), children: /* @__PURE__ */ r.jsx(
        d,
        {
          label: /* @__PURE__ */ r.jsxs("div", { className: "cur-flex cur-w-full cur-justify-between", children: [
            a,
            s && /* @__PURE__ */ r.jsx(
              f,
              {
                className: "cur-absolute cur-right-0 cur-justify-self-end",
                labelType: "good",
                children: "Recommended"
              }
            )
          ] }),
          ref: i,
          ...c,
          children: e
        }
      ) });
    }
  )
);
export {
  R as ControlCardRadioButton
};
//# sourceMappingURL=index.js.map
